// import { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
// @mui
import { Box, styled } from '@mui/material';

// const APP_BAR_MOBILE = 64;
// const APP_BAR_DESKTOP = 70; // 92;

const Main = styled('div')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  minHeight: '100%',
  // paddingTop: APP_BAR_MOBILE + 24,
  // paddingBottom: theme.spacing(10),
  [theme.breakpoints.up('lg')]: {
    // paddingTop: APP_BAR_DESKTOP + 24,
    // paddingLeft: theme.spacing(2),
    // paddingRight: theme.spacing(2),
  },
}));


export default function PublicLayout() {

  return (
    <>
      <Main>
        <Outlet />
      </Main>
    </>
  );
}
